import { a as b, u as v } from "./chunk-useConsent-CCy0U1xk.js";
const A = (e, r, u) => {
  const s = r / 100 / 360 * 30, a = e * s / (1 - Math.pow(1 + s, -u));
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    roundingMode: "ceil",
    maximumFractionDigits: 0,
    // @ts-ignore
    trailingZeroDisplay: "stripIfInteger"
  }).format(a);
}, h = !1;
b(
  () => p(),
  () => S(),
  ["marketing", "analytics"],
  h
);
const S = () => {
  window._affirm_config = void 0, window.affirm = void 0, document.querySelectorAll("affirm-messaging").forEach((e) => {
    e.reRender();
  });
}, p = (e) => {
  const r = window.__VENDORS__.affirm.publicApiKey;
  !window.__VENDORS__.affirm.enabled || !r || (window._affirm_config = {
    public_api_key: r,
    script: "https://cdn1.affirm.com/js/v2/affirm.js"
  }, (function(s, a, d, m, t, c, i) {
    var o, n = s[d] || {}, f = document.createElement(c), g = document.getElementsByTagName(c)[0], l = function(w, _, E) {
      return function() {
        w[_]._.push([E, arguments]);
      };
    };
    for (n[m] = l(n, m, "set"), o = n[m], n[t] = {}, n[t]._ = [], o._ = [], n[t][i] = l(n, t, i), t = 0, i = "set add save post open empty reset on off trigger ready setProduct".split(
      " "
    ); t < i.length; t++)
      o[i[t]] = l(n, m, i[t]);
    for (t = 0, i = ["get", "token", "url", "items"]; t < i.length; t++)
      o[i[t]] = function() {
      };
    f.async = !0, f.src = a[c], g.parentNode.insertBefore(f, g), delete a[c], o(a), s[d] = n;
  })(window, _affirm_config, "affirm", "checkout", "ui", "script", "ready"), affirm.ui.ready(function() {
    e && affirm.ui.openModal(e);
  }));
};
class T extends HTMLElement {
  constructor() {
    super(), this.pageType = this.getAttribute("data-page-type"), this.amount = Number(this.getAttribute("data-amount")), this.dollars = this.getAttribute("data-dollars"), this.months = Number(this.getAttribute("data-months")), this.rate = 15;
  }
  connectedCallback() {
    this.initialState = this.innerHTML, this.render();
  }
  render() {
    this.monthlyPayment = this.querySelector("[data-monthly-payment]"), this.monthlyPayment.innerText = A(
      this.dollars,
      this.rate,
      this.months
    ), this.setUpListeners();
  }
  reRender() {
    this.innerHTML = this.initialState, this.render();
  }
  setUpListeners() {
    this.modalTrigger = this.querySelector("[data-affirm-modal-trigger]"), this.modalTrigger.addEventListener("click", (r) => {
      r.preventDefault(), v(
        () => p({
          page_type: this.pageType,
          amount: this.amount
        }),
        null,
        ["marketing", "analytics"],
        !0,
        h
      ), y();
    });
  }
}
window.customElements.get("affirm-messaging") || window.customElements.define("affirm-messaging", T);
const y = () => {
  document.querySelector("app-provider").dispatchEvent(
    new CustomEvent("modal-dialog::close", {
      bubbles: !0,
      composed: !0,
      detail: "cart-drawer-dialog"
    })
  );
};
document.addEventListener("click", (e) => {
  e.target.classList.contains("affirm-modal-trigger") && y();
});
